
<template>
  <card>
    <div class="row">
      <div class="col-12 col-md-7">
        <div class="card">
          <div class="card-body">
            <h5>Ana Menü <small class="text-info">Menü sıralamasını değiştirmek için sürükleyin </small></h5>
            <draggable v-model="menus" :options="{animation:200}" @update="update()">
              <transition-group>
                <div v-for="menu in menus" :key="menu.id">
                  <div class="card mb-2 menu-item">
                    <div class="card-body row">
                      <div class="col-9">{{menu.name}}</div>
                      <div class="col-3 d-flex justify-content-end">
                        <div> 
                          <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-on:click="remove(menu.id)" v-b-tooltip title="Sil"><i class="fas fa-times"></i></a> 
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <div class="card">
          <div class="card-body">
            <h5>Ekle</h5>
            <div class=" input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Başlık</span>
              </div>
              <input type="text" class="form-control" placeholder="Başlık" v-model="menu.name" id="name">
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text border-0 bg-white" for="inputGroupSelect01">Tür</label>
              </div>
              <select class="form-control" v-on:change="loadItems" v-model="selectedType">
                <option v-for="item in types" :key="item" :value="item">{{item}}</option>
              </select>
            </div>
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="URL" v-if="selectedType == 'URL'" v-model="menu.url" id="name">
              <model-select :options="options" v-model="menu.category_id" v-if="selectedType == 'Kategori'" placeholder="Kategori" class="form-control"></model-select>
              <model-select :options="options" v-model="menu.sub_category_id" v-if="selectedType == 'Alt Kategori'" placeholder="Alt Kategori" class="form-control"></model-select>
              <model-select :options="options" v-model="menu.post_id" v-if="selectedType == 'Yayın'" placeholder="Yayın" class="form-control"></model-select>
              <model-select :options="options" v-model="menu.tag_id" v-if="selectedType == 'Etiket'" placeholder="Etiket" class="form-control"></model-select>
            </div>
            <button class="btn btn-success btn-fill" @click="save()">Ekle</button>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import { ModelSelect } from 'vue-search-select'

  export default {
    data: function () {
      return {
        menu:{
          name:null,
          item_order:null,
          url:null,
          category_id:null,
          post_id:null,
          tag_id:null,
          sub_category_id:null,
        },
        selectedType: null,
        types : ['URL','Kategori','Alt Kategori','Yayın','Etiket'],
        options: [],
        menus: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'all',
        viewCounts: []
      }
    },
    components: {
      Card,
      ModelSelect
    },

    methods: {
      remove: function(id){
        this.toggleLoader()
        this.$http.post('/api/menus/delete/' + id).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Menu elemanı silindi')
            this.getMenus()
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      loadItems: function(){
        this.options = []
        var resourse = null
        if(this.selectedType === "URL"){
          this.menu.category_id = null
          this.menu.sub_category_id = null
          this.menu.post_id = null
          this.menu.tag_id = null
          return
        }else if(this.selectedType === 'Kategori'){
          resourse = 'categories'
          this.menu.url = null
          this.menu.sub_category_id = null
          this.menu.post_id = null
          this.menu.tag_id = null
        }else if(this.selectedType === 'Alt Kategori'){
          resourse = 'sub-categories'
          this.menu.url = null
          this.menu.category_id = null
          this.menu.post_id = null
          this.menu.tag_id = null
        }else if(this.selectedType === 'Yayın'){
          resourse = 'posts'
          this.menu.url = null
          this.menu.sub_category_id = null
          this.menu.category_id = null
          this.menu.tag_id = null
        }else if(this.selectedType === 'Etiket'){
          this.menu.url = null
          this.menu.sub_category_id = null
          this.menu.post_id = null
          this.menu.category_id = null
          resourse = 'tags'
        }
        this.toggleLoader()
        var url = '/api/' + resourse + '/all/'
        this.$http.get(url).then(
          response => {
            response = response.body
            for (var i = 0; i < response.length; i++) {
              var temp = {value:response[i].id,text:response[i].name}
              this.options.push(temp)
            }
            this.toggleLoader()
          },
          er => {
            this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            this.toggleLoader()
          })
      },
      update: function(id){
        this.$http.post('/api/menus/edit/', this.menus).then(
          response => {
            this.notifier('top', 'right', 'success', 'Sıralama güncellendi')
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          })
      },
      save: function(id){
        this.menu.item_order = this.menus.length
        this.toggleLoader()
        this.$http.post('/api/menus/add/', this.menu).then(
          response => {
            this.menu = {
              name:null,
              item_order:null,
              url:null,
              category_id:null,
              post_id:null,
              tag_id:null,
              sub_category_id:null,
            }
            this.getMenus()
            this.toggleLoader()
            this.notifier('top', 'right', 'success', 'Sıralama güncellendi')
          },
          e => {
            this.toggleLoader()
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          })
      },
      getMenus: function () {
        this.toggleLoader()
        var url = '/api/menus/all/'
        this.$http
        .get(url)
        .then(
          response => {
            this.menus = response.body
            this.toggleLoader()
          },
          er => {
            this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            this.toggleLoader()
          })
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getMenus()
      })
    }
  }
</script>
<style>
.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  background-color: #007bff !important;
}
.nav-pills:focus{
  outline: none;
}
.nav-pills a{
  color:#000;
}

.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  color:#fff;
}
.nav-item{
  margin-bottom: 5px;
}
.menu-item:hover{
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MenuModules/Index.vue